export enum Status {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR"
}
